<template>
    <b-modal v-model="show" title="АНАЛОГ СОЗЛАШ" :centered="true" size="lg" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                  <div class="card card-tasks">
                    <div class="card-header">
                      <h4 class="card-title">
                        <span v-if="item">
                          Аналог созлаш: {{item.analogSettingId}}
                        </span>
                      </h4>
                    </div>
                    <div class="card-body">
                      <table class="table">
                        <tbody v-if="analogs">
                        <tr v-for="analog in analogs" :key="analog.analogId">
                          <td>
                              <div class="form-check pl-0 checkbox-inline">
                              <label class="form-check-label"
                                     style="padding-left:22px !important">
                                <input class="form-check-input" type="checkbox"
                                       v-model="analog.select"
                                >
                                <span class="form-check-sign"></span>
                              </label>
                            </div>
                          </td>
                          <td>
                            <a :href="`https://e-rieltor.uz/products/product/${analog.analogId}`" target="_blank">{{"https://e-rieltor.uz/products/product/"+ analog.analogId}}</a>
                          </td>
                          <template v-if="analogSetting">
                            <td>
                              <span v-if="analog.province">{{analog.province.name}}</span>
                            </td>
                            <td>
                              <span v-if="analog.region">{{analog.region.name}}</span>
                            </td>
                            <td>
                              <span v-if="analog.mfy">{{analog.mfy.name}}</span>
                            </td>
                          </template>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
          <button class="all-btn add-btn float-right" @click="onUpdatingAnalog" :disabled="processing">
            {{$t('action.refresh')}}
          </button>
          <button class="all-btn delete-btn float-right mr-2" @click="show = false">
            {{$t('action.cancel')}}
          </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    export default {
        name: "AnalogSettingEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                loading: false,
                analogSetting: null,
                analogs: [],
                item: null
            }
        },
        methods: {
          editAnalogSetting(analogSettingId) {
            this.loading = true;
            this.$http.get(`/analog-setting/${analogSettingId}`)
                .then(res => {
                  this.analogSetting = res.data
                  this.loading = false;

                }).catch(({response}) => {
                  console.log('error')
                  console.log(response)

                  this.$swal({
                    type: 'error',
                    title: '',
                    text: response && response.data.message ? response.data.message : response.data
                  });

                  this.loading = false;
            })
          },
         onUpdatingAnalog() {
           const existingAnalogs = []
           this.analogs.forEach((analog) => {
             if (analog.select) {
               existingAnalogs.push(analog.analogId)
             }
           })

           if (existingAnalogs.length > 0) {
             this.$swal({
               title: 'Янгилашни амалга оширасизми?',
               text: 'Янгилаш учун "Тасдиқлаш" кнопкасини босинг',
               type: 'warning',
               showCancelButton: true,
               confirmButtonColor: '#78b414',
               cancelButtonColor: '#d33',
               confirmButtonText: 'Тасдиқлаш',
               cancelButtonText: 'Бекор қилиш'
             }).then((result) => {
               if (result.value) {
                 this.processing = true;
                 this.$http.post('/analog-setting/update-by-item', {id: this.item.id, category:  this.item.category, analogSettingId: this.item.analogSettingId , existingAnalogs: existingAnalogs})
                     .then(res => {
                       let resData = res.data;
                       if (resData.status === 'SUCCESS') {
                         this.show = false;
                         this.$emit('change');
                       }
                       this.processing = false;

                     }).catch(({response}) => {
                       console.log('error')
                       console.log(response)

                       this.$swal({
                         type: 'error',
                         title: '',
                         text: response && response.data.message ? response.data.message : response.data
                       });

                   this.processing = false;
                 })
               }
             })
           }
          }
        },
        created() {
           this.$eventBus.$on('showAnalogSettingItemAnalogsModal', (data) => {
               if (data) {
                 this.item = data
                 this.analogs = data.analogs
                 this.editAnalogSetting(data.analogSettingId);
               }
               this.show = true;
           });
        }
    }
</script>

<style scoped>

</style>